import script from "./AppPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppPage.vue?vue&type=script&setup=true&lang=ts"

import "./AppPage.vue?vue&type=style&index=0&id=36de2d37&lang=css"

const __exports__ = script;

export default __exports__